export default "__VITE_ASSET__7194fe46__"